/* <site-header>: publishes --header-height and toggles .is-scrolled (used by the transparent header). */
class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.transparent = this.dataset.transparent === 'true';
    this.setHeight();
    this.ro = new ResizeObserver(() => this.setHeight());
    this.ro.observe(this);
    if (this.transparent) {
      this.sentinel = document.createElement('div');
      this.sentinel.setAttribute('aria-hidden', 'true');
      this.sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:24px;pointer-events:none';
      document.body.prepend(this.sentinel);
      this.io = new IntersectionObserver(([entry]) => {
        this.classList.toggle('is-scrolled', !entry.isIntersecting);
      });
      this.io.observe(this.sentinel);
      this.addEventListener('mouseenter', () => this.classList.add('is-scrolled'));
      this.addEventListener('mouseleave', () => {
        if (this.sentinel.getBoundingClientRect().bottom > 0) this.classList.remove('is-scrolled');
      });
    }
  }
  disconnectedCallback() {
    if (this.ro) this.ro.disconnect();
    if (this.io) this.io.disconnect();
    if (this.sentinel) this.sentinel.remove();
  }
  setHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
  }
}
if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);

/* <announcement-bar>: rotates messages */
class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.announcement__msg')];
    if (this.items.length < 2) return;
    this.index = 0;
    const delay = (Number(this.dataset.speed) || 5) * 1000;
    this.timer = setInterval(() => this.show((this.index + 1) % this.items.length), delay);
    this.addEventListener('mouseenter', () => clearInterval(this.timer));
  }
  disconnectedCallback() { clearInterval(this.timer); }
  show(i) {
    this.items[this.index].classList.remove('is-active');
    this.items[i].classList.add('is-active');
    this.index = i;
  }
}
if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);
